import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICompanyBrandingService } from "services/CompanyBrandingService";
import { CompanyBrandingModel, LoginScreenNarrativeModel } from "services/api/cplauthapi/CPLAuthAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

type companyBrandingProps = {
  loading: boolean;
  failed: boolean;
  companyBranding: CompanyBrandingModel | undefined;
  loginScreenNarrative: LoginScreenNarrativeModel | undefined;
};

const initialState: companyBrandingProps = {
  loading: false,
  failed: false,
  companyBranding: undefined,
  loginScreenNarrative: undefined,
};

const companyBrandingSlice = createSlice({
  name: "companyBrandingLoader",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyBranding.fulfilled, (state, action) => {
        state.loading = false;
        state.companyBranding = action.payload;
      })
      .addCase(getCompanyBranding.rejected, (state) => {
        state.companyBranding = undefined;
        state.loading = false;
        state.failed = true;
      })
      .addCase(getCompanyBranding.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLoginScreenNarrative.fulfilled, (state, action) => {
        state.loading = false;
        state.loginScreenNarrative = action.payload;
      })
      .addCase(getLoginScreenNarrative.rejected, (state) => {
        state.loginScreenNarrative = undefined;
        state.loading = false;
      })
      .addCase(getLoginScreenNarrative.pending, (state) => {
        state.loading = true;
      });
  },
});

export const getCompanyBranding = createAsyncThunk(
  "companyBrandingLoader/getCompanyBranding",
  async (companyID: string) => {
    const companyBrandingService = container.get<ICompanyBrandingService>(SERVICE_TYPES.CompanyBrandingService);
    return await companyBrandingService.getCompanyBranding(companyID);
  }
);

export const getLoginScreenNarrative = createAsyncThunk(
  "companyBrandingLoader/getLoginScreenNarrative",
  async (companyID: string) => {
    const companyBrandingService = container.get<ICompanyBrandingService>(SERVICE_TYPES.CompanyBrandingService);
    return await companyBrandingService.getLoginScreenNarrative(companyID);
  }
);

export const selectBrandingLoading = (state: RootState) => state.companyBranding.loading;
export const selectBrandingFailed = (state: RootState) => state.companyBranding.failed;
export const selectCompanyBranding = (state: RootState) => state.companyBranding.companyBranding;
export const selectLoginScreenNarrative = (state: RootState) => state.companyBranding.loginScreenNarrative;

export default companyBrandingSlice.reducer;
